var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('student-profile-card',{attrs:{"studentId":_vm.id}}),_vm._v(" "),(
			_vm.logPropsData ||
			_vm.basicInfoPropsData ||
			_vm.languagePropsData ||
			_vm.personalPropsData ||
			_vm.marketingPropsData ||
			_vm.placementPropsData ||
			_vm.schedulePropsData ||
			_vm.financePropsData ||
			_vm.classPropsData ||
			_vm.packagesPropsData ||
			_vm.invoicePropsData||
			_vm.vanumberPropsData
		)?_c('div',{staticClass:"mb-primary"},[_c('div',{staticClass:"card p-primary border-0"},[_c('student-profile-form-wizard',{attrs:{"tabs":_vm.computedTabs}})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }